import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {
  CreatePppLinkRequestBody,
  DeletePppLinkPath,
  GetPppLinksQuery,
  IPppLinkObject,
  UpdatePppLinkPath,
} from "../../interfaces/pppLink.interface";
import {
  createPppLink,
  deletePppLink,
  listPppLinks,
  updatePppLink,
} from "./pppLinksApi";

export interface PppLinksState {
  links: IPppLinkObject[];
  isLoading: boolean;
  lastUpdatedKey: string;
}

const initialState: PppLinksState = {
  links: [],
  isLoading: false,
  lastUpdatedKey: "",
};

export const listPppLinksThunk = createAsyncThunk(
  "pppLinks/list",
  async (query: GetPppLinksQuery) => {
    const res = await listPppLinks(query);
    return res.links;
  }
);

export const createPppLinkThunk = createAsyncThunk(
  "pppLinks/create",
  async (body: CreatePppLinkRequestBody) => {
    const res = await createPppLink(body);
    return res.link;
  }
);

export const updatePppLinkThunk = createAsyncThunk(
  "pppLinks/update",
  async (args: { path: UpdatePppLinkPath; body: any }) => {
    const res = await updatePppLink(args.path, args.body);
    return res.link;
  }
);

export const deletePppLinkThunk = createAsyncThunk(
  "pppLinks/delete",
  async (path: DeletePppLinkPath) => {
    await deletePppLink(path);
    return path.code;
  }
);

export const pppLinksSlice = createSlice({
  name: "pppLinks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listPppLinksThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listPppLinksThunk.fulfilled, (state, action) => {
        state.links = action.payload;
        state.isLoading = false;
      })
      .addCase(listPppLinksThunk.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createPppLinkThunk.fulfilled, (state, action) => {
        state.links = [action.payload, ...state.links];
        state.lastUpdatedKey = Date.now().toString();
      })
      .addCase(updatePppLinkThunk.fulfilled, (state, action) => {
        const updated = action.payload;
        state.links = state.links.map((l) => (l._id === updated._id ? updated : l));
        state.lastUpdatedKey = Date.now().toString();
      })
      .addCase(deletePppLinkThunk.fulfilled, (state, action) => {
        const code = action.payload;
        state.links = state.links.filter((l) => l.code !== code);
        state.lastUpdatedKey = Date.now().toString();
      });
  },
});

export const selectPppLinks = (state: RootState) => state.pppLinks.links;
export const selectPppLinksLoading = (state: RootState) => state.pppLinks.isLoading;
export const selectPppLinksLastUpdatedKey = (state: RootState) => state.pppLinks.lastUpdatedKey;

export default pppLinksSlice.reducer;


